import AssetPreview from 'framework-asset-preview-lib/internal/assetPreview/components/AssetPreview';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ConnectedAssetPreviewCard(props) {
  return /*#__PURE__*/_jsx(AssetPreview, Object.assign({}, props));
}